export function parseBodyVariables(bodyText) {
  if (!bodyText) return [];
  const variablePattern = /\{\{(\d+)\}\}/g;
  const variables = [];
  let match;
  // eslint-disable-next-line no-cond-assign
  while ((match = variablePattern.exec(bodyText)) !== null) {
    const variableNumber = parseInt(match[1], 10);
    if (!variables.includes(variableNumber)) variables.push(variableNumber);
  }
  return variables.sort((a, b) => a - b);
}

export function extractPhoenixParameters(translation) {
  const links = { header: [], body: [], buttons: [] };
  if (!translation?.components) return links;

  translation.components.forEach((component) => {
    if (
      component.type === 'HEADER' &&
      component.format &&
      !this.isPhoenixListSend
    ) {
      const editableHeaderFormats = ['image', 'video'];
      const fmt = String(component.format || '').toLowerCase();
      if (editableHeaderFormats.includes(fmt)) {
        links.header.push({
          example: component.example?.header_handle?.[0] || '',
          number: 1,
          value: '',
          valueType: fmt,
        });
      }
    }
    if (component.type === 'BODY' && component.text) {
      const variables = parseBodyVariables(component.text);
      const examples = component.example?.body_text?.[0] || [];
      variables.forEach((variableNumber, index) => {
        links.body.push({
          example: examples[index] || `Parameter ${variableNumber}`,
          number: variableNumber,
          value: '',
          valueType: 'attributes',
        });
      });
    }
    if (component.type === 'BUTTONS' && Array.isArray(component.buttons)) {
      component.buttons.forEach((button, index) => {
        if (button.type === 'URL' && /\{\{\d+\}\}/.test(button.url || '')) {
          links.buttons.push({
            example: (Array.isArray(button.example) ? button.example[0] : button.example) || '',
            number: index,
            value: '',
            valueType: 'static_text',
          });
        }
      });
    }
  });
  return links;
}
